import React from 'react';
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import {toast} from "react-toastify";
import API from "../../Services/API";
import {GiTwoCoins} from "react-icons/gi";
import {useNavigate} from "react-router-dom";
import Navbar from "../../Layouts/Navbar";
import {BsShop} from "react-icons/bs";


const currencyFormat = Intl.NumberFormat('en-US');

function Discounts() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(true);
    const [products, setProducts] = React.useState([]);


    React.useEffect(() => {

            setIsLoaded(false);
            const params = {

            }
            API.DiscountsProducts(params)
                .then((response) => {

                    setProducts(response.data);
                    setIsLoaded(true);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });

    }, []);



    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header title='تخفیف دارها' hasBack={true}/>
            <section className="container-fluid  mt-1 py-5 mb-4 rtl px-0 mx-0 ">


                {
                    isLoaded && products.map(product => {
                            const price = product.price * (1 - (product.discount_percent / 100))
                            return (
                                <div className="row mx-2 product-search-card  mx-2 pt-2 px-0 " key={product.id}
                                     onClick={() => {
                                         navigate(`/vendor/${product.vendor_id}`);
                                     }}
                                >
                                    <div className="col-3 border-bottom pb-3 ">
                                        <img src={product.cover_image} alt={product.name} className='product-img' />
                                    </div>
                                    <div className="col-9 fw-bolder text-small-2 text-muted border-bottom pb-3 ">

                                        {product.name}
                                        <span className='tr_code badge badge-pill badge-primary bg-primary-color mx-2 text-small-3 float-start'>
                                            {
                                                 product.discount_percent
                                            }
                                            %
                                        </span>
                                        {product.price ?
                                            <div className='price-with-discount mt-3'>

                                                <GiTwoCoins className='ms-2 '/>
                                                {
                                                    product.discount_percent &&
                                                    <span
                                                        className='text-decoration-line-through fw-normal text-small-2 px-2 '>
                                                       {currencyFormat.format(product.price)}
                                                        &nbsp;
                                                        ریال
                                            </span>
                                                }
                                                {currencyFormat.format(price)}
                                                &nbsp;
                                                ریال
                                                &nbsp;

                                            </div> :
                                            <div className='text-small-2 text-muted'>
                                                <GiTwoCoins className='mx-2'/>
                                                توافقی
                                            </div>
                                        }
                                    </div>


                                    <div className="col-10 py-2 text-small-3 fw-bold text-muted opacity-75 "
                                    >
                                        <BsShop className='mx-2 text-secondary ' />
                                                               {product.vendor}
                                    </div>
                                    <div className="col-2 py-2 text-small-2 text-muted ">


                                        <img src={product.vendor_image} alt={product.vendor} className='product-img opacity-50 gray-img' />

                                    </div>


                                </div>
                            );
                        }
                    )
                }
            </section>
            <Navbar />
        </React.Fragment>
    );
}

export default Discounts;